import { Component, HostBinding, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { UserService } from 'src/app/services/user.service';
import { getEstablishmentImage } from 'src/app/utils/images';
import {
  getPartnershipBadge,
  PARTNERSHIP_BADGE_ICONS,
  PARTNERSHIP_BADGE_LABELS,
  PartnershipBadgeType,
} from 'src/app/utils/partnership-badge';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'establishment-card',
  templateUrl: './establishment-card.component.html',
  styleUrls: ['./establishment-card.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class EstablishmentCardComponent implements OnInit {

  @HostBinding('class') @Input('class') class = '';

  @Input() establishment;
  @Input() userRole;
  @Input() loggedUser;
  @Input() online = false;

  nearestAddress: any;
  businessName: string;
  imagePath: string;
  loading = false;
  activeAccount;


  constructor(
    private userService: UserService
  ) {}


  ngOnInit() {
    this.activeAccount = this.userService.getLoggedAccount();
    this.businessName = this.loggedUser && this.activeAccount.name;
    this.nearestAddress = this.getNearestAddress(this.establishment.addressess);
    this.imagePath = getEstablishmentImage(this.establishment, 'logo');
  }

  getNearestAddress = addresses => addresses ? addresses.reduce((m, k) => k.distance > m.distance ? m : k) : null;

  editOwnPartnership() {
    if (!this.establishment || !this.establishment.id) {
      return;
    }

    const id = encodeURIComponent(this.establishment.id);
    window.location.href = `${environment.PORTAL_URL}/dashboard/parcerias-exclusivas/cadastrar?id=${id}`;
  }

  get partnershipBadge(): PartnershipBadgeType {
    return getPartnershipBadge(this.establishment);
  }

  get partnershipBadgeIcon(): string | null {
    return this.partnershipBadge ? PARTNERSHIP_BADGE_ICONS[this.partnershipBadge] : null;
  }

  get partnershipBadgeAlt(): string {
    return this.partnershipBadge ? PARTNERSHIP_BADGE_LABELS[this.partnershipBadge] : '';
  }

}
